import { render, staticRenderFns } from "./Get_events.vue?vue&type=template&id=5a23bb2b&scoped=true"
import script from "./Get_events.vue?vue&type=script&lang=js"
export * from "./Get_events.vue?vue&type=script&lang=js"
import style0 from "./Get_events.vue?vue&type=style&index=0&id=5a23bb2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a23bb2b",
  null
  
)

export default component.exports